import {Card} from "../../../basic/card.tsx";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {VwpLicense} from "../../../../store/generated/api.ts";

interface LicenseStatsProps {
    licenses: VwpLicense[];
    summary: {
        totalLicenses: number;
        totalAvailableSeats: number;
        totalAssignedSeats: number;
        expiringSoon: number;
    };
}

export function LicenseStats({licenses, summary}: LicenseStatsProps) {
    const {t} = useTranslationWithKeys();

    // Use summary data from API for accurate totals
    const totalLicenses = summary.totalLicenses;
    const totalAvailable = summary.totalAvailableSeats;
    const totalAssigned = summary.totalAssignedSeats;
    const expiringSoon = summary.expiringSoon;

    return (
        <div className="grid gap-6 md:grid-cols-4">
            <Card className="p-6 shadow-sm border-border/50">
                <p className="text-muted-foreground">{t('licenses.totalLicenses')}</p>
                <p className="mt-1">{totalLicenses}</p>
            </Card>
            <Card className="p-6 shadow-sm border-border/50">
                <p className="text-muted-foreground">{t('licenses.assigned')}</p>
                <p className="mt-1">{totalAssigned}</p>
            </Card>
            <Card className="p-6 shadow-sm border-border/50 bg-accent/30">
                <p className="text-muted-foreground">{t('licenses.available')}</p>
                <p className="mt-1">{totalAvailable}</p>
            </Card>
            <Card className="p-6 shadow-sm border-border/50">
                <p className="text-muted-foreground">{t('licenses.expiring30d')}</p>
                <p className="mt-1">{expiringSoon}</p>
            </Card>
        </div>
    );
}